import partner1 from "src/shared/assets/partners/partner1.png";
import partner2 from "src/shared/assets/partners/partner2.svg";
import partner3 from "src/shared/assets/partners/partner3.png";
import partner4 from "src/shared/assets/partners/partner4.webp";
import partner5 from "src/shared/assets/partners/partner5.svg";
import partner6 from "src/shared/assets/partners/partner6.webp";
import partner7 from "src/shared/assets/partners/partner7.svg";
import partner8 from "src/shared/assets/partners/partner8.svg";
import partner9 from "src/shared/assets/partners/partner9.svg";
import partner10 from "src/shared/assets/partners/partner10.svg";
import partner11 from "src/shared/assets/partners/partner11.svg";
import partner12 from "src/shared/assets/partners/partner12.webp";

// Real company names (verified against each logo file, cross-checked against
// Sven's LinkedIn profile banner, which shows the same 10 of these 12 logos
// together — SEO_GEO_CHANGELOG.md, "[Task 5]"). Previously these were all
// alt="Partner N", which gave crawlers and screen readers no way to know
// which companies these are — a real loss given this is direct social proof
// for decision-makers.
export const partnersMarqueeData = [
  {
    alt: "Ippen Digital",
    aspectRatio: 4.471,
    image: partner1,
  },
  {
    alt: "Zalando",
    aspectRatio: 5.0,
    image: partner2,
  },
  {
    alt: "Microsoft",
    aspectRatio: 4.696,
    image: partner3,
  },
  {
    alt: "Infineon",
    aspectRatio: 4.26,
    image: partner4,
  },
  {
    alt: "Ströer",
    aspectRatio: 4.75,
    image: partner5,
  },
  {
    alt: "testo",
    aspectRatio: 1.0,
    image: partner6,
  },
  {
    alt: "Merck",
    aspectRatio: 3.339,
    image: partner7,
  },
  {
    alt: "Schubert",
    aspectRatio: 5.0,
    image: partner8,
  },
  {
    alt: "DocGaid",
    aspectRatio: 2.716,
    image: partner9,
  },
  {
    alt: "Anyline",
    aspectRatio: 4.188,
    image: partner10,
  },
  {
    alt: "HUK-COBURG",
    aspectRatio: 2.104,
    image: partner11,
  },
  {
    alt: "nexenio",
    aspectRatio: 4.66,
    image: partner12,
  },
];
